import { API } from 'aws-amplify';
import { auth, getAuthHeaders } from './auth';
import { MemberOrderResponse } from '../data_types/member-order';

const getMembershipInfo = async (): Promise<MemberOrderResponse> => {
    const session = await auth.getSession();

    if (!session.authenticated) {
        throw new Error('Not authenticated');
    }

    const response = await API.get('membership', '/membership-info', {
        headers: getAuthHeaders(),
        queryStringParameters: {
            id: session.user!.contactId,
        },
    });

    return response.data;
};

export default getMembershipInfo;
